/**
 * ASCII Hero Engine - Color & Geometry Helpers
 */

/**
 * Helper to convert hex colors or rgb arrays to [r, g, b]
 * @param {string|Array<number>} color
 * @returns {Array<number>} [r, g, b]
 */
export function parseColorToRgb(color) {
  if (Array.isArray(color) && color.length >= 3) return color;
  if (typeof color === "string") {
    let c = color.replace("#", "").trim();
    if (c.startsWith("rgba(") || c.startsWith("rgb(")) {
      const match = c.match(/\d+/g);
      if (match && match.length >= 3) {
        return [parseInt(match[0], 10), parseInt(match[1], 10), parseInt(match[2], 10)];
      }
    }
    if (c.length === 3) c = c.split("").map((x) => x + x).join("");
    if (c.length === 6) {
      const num = parseInt(c, 16);
      return [(num >> 16) & 255, (num >> 8) & 255, num & 255];
    }
  }
  return [255, 255, 255];
}

/**
 * Ray-casting point-in-polygon test (normalized 0..1 coordinates)
 * @param {number} u Normalized horizontal coordinate (0..1)
 * @param {number} v Normalized vertical coordinate (0..1)
 * @param {Array<Array<number>>} polygon Array of [u, v] polygon vertices
 * @returns {boolean}
 */
export function isPointInPolygon(u, v, polygon) {
  if (!polygon || polygon.length < 3) return false;
  let inside = false;
  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const xi = polygon[i][0];
    const yi = polygon[i][1];
    const xj = polygon[j][0];
    const yj = polygon[j][1];
    const intersect = yi > v !== yj > v && u < ((xj - xi) * (v - yi)) / (yj - yi) + xi;
    if (intersect) inside = !inside;
  }
  return inside;
}
